import React from 'react';
import { reducer, initialState } from "../reducers/reducer"

export const AppContext = React.createContext({
  state: initialState,
  dispatch: () => null
})

export const ContextProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(reducer, initialState)

  console.debug("State Update:", state)

  return (
    <AppContext.Provider value={[ state, dispatch ]}>
    	{ children }
    </AppContext.Provider>
  )
}

